var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-messages theme--light message-caption",class:{ clickable: _vm.actionContext },domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }